import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MotifCardModule, MotifModal, MotifModalModule, MotifButtonModule, MotifIconModule, MotifDropdownModule, MotifDatePickerModule, Placement, ScrollStrategy } from '@ey-xd/ng-motif';
import { AddDeliverableTemplatePanelComponent } from '@sa/app/components/deliverable-management/deliverable-template/add-deliverable-template-panel/add-deliverable-template-panel.component';
import { DeliverableTemplateComponent } from '@sa/app/components/deliverable-management/deliverable-template/deliverable-template.component';
import { ReplicateDeliverablePanelComponent } from '@sa/app/components/replicate-deliverable-panel/replicate-deliverable-panel.component';
import { TransitionReplicatePanelComponent } from '@sa/app/components/transition-replicate-panel/transition-replicate-panel.component';
import { ISelectionDetails } from '@sa/app/shared/interfaces/selection-details';
import { CommonService } from '@sa/app/shared/services/common.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-deliverable-management-view',
  standalone: true,
  imports: [CommonModule, MotifCardModule, MotifModalModule, MotifButtonModule, MotifIconModule, MotifDropdownModule, MotifDatePickerModule, DeliverableTemplateComponent],
  templateUrl: './deliverable-management-view.component.html',
  styleUrl: './deliverable-management-view.component.scss',
})
export class DeliverableManagementViewComponent {
  selectedClientDetails: ISelectionDetails | null = null;
  private destroy$ = new Subject<void>();
  commonService = inject(CommonService);
  Placement = Placement;
  ScrollStrategy = ScrollStrategy;

  constructor(private modal: MotifModal) {}

  addDeliverable(): void {
    const modalRef = this.modal.open(AddDeliverableTemplatePanelComponent, {
      slideout: true,
      data: {},
    });
    modalRef
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result === true) {
          // Trigger refresh in child component
          this.triggerChildRefresh();
        }
      });
  }
  private triggerChildRefresh(): void {
    this.commonService.triggerDataRefresh();
  }

  openReplicateModal() {
    // Get tenant GUID from common service
    const tenantGuid = this.commonService.getState('selectedTenantGuid');
    if (!tenantGuid) {
      console.error('Tenant GUID is not available');
      return;
    }
    try {
      this.modal.open(ReplicateDeliverablePanelComponent, {
        slideout: true,
        data: {
          tenantGuid: tenantGuid
        }
      });
    } catch (error) {
      console.error('Error opening replicate modal:', error);
    }
  }

  openTransitionReplicateModal(): void {
    const tenantGuid = this.commonService.getState('selectedTenantGuid');
    if (!tenantGuid) {
      console.error('Tenant GUID is not available');
      return;
    }
    try {
      const modalRef = this.modal.open(TransitionReplicatePanelComponent, {
        slideout: true,
        data: {
          tenantGuid: tenantGuid,
        },
      });
      modalRef.afterClosed().subscribe((result) => {
        if (result === true) {
          this.triggerChildRefresh();
        }
      });
    } catch (error) {
      console.error('Error opening transition replicate modal:', error);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}